import PropTypes from 'prop-types'
import NotificationField from './NotificationField'

const ResponseField = ({ consumption }) => {
  if (!consumption || Object.entries(consumption).length === 0) {
    return
  }

  return (
    <NotificationField
      carBase={consumption?.car_elec_base}
      carHp={consumption?.car_elec_hp}
      carHc={consumption?.car_elec_hc}
      carGas={consumption?.car_gas}
    />
  )
}

ResponseField.propTypes = {
  consumption: PropTypes.object,
}

export default ResponseField
